module.exports = __webpack_public_path__ + "src/assets/img/4_6art_2part.9273b8bc.jpg";